module.exports = __webpack_public_path__ + "static/media/trademark_opposition.3b55bff1.png";